import script from "./ManageCampaignTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageCampaignTable.vue?vue&type=script&setup=true&lang=js"

import "./ManageCampaignTable.vue?vue&type=style&index=0&id=596cf6aa&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-596cf6aa"]])

export default __exports__